import { Layout } from "@Components/Layout";
import dynamic from "next/dynamic";
const Cookies = dynamic(() =>
  import("@Components/Pages/Pre-Footer/Cookies-Policy")
);
const cookiePolicyPage = () => {
  return (
    <Layout>
      <Cookies />
    </Layout>
  );
};
export default cookiePolicyPage;
